interface ICircularQueue<T> {
  enqueue(item: T): void;
  dequeue(): T | undefined;
  moveForward(): T | undefined;
  moveBack(): T | undefined;
  getCurrentElement(): T | undefined;
  size(): number;
  serialize(): string;
  getStorage(): T[];
  getCurrentIndex(): number;
}

export class CircularQueue<T> implements ICircularQueue<T> {
  capacity: number;
  pointer: number;
  storage: T[];

  constructor(capacity = Infinity, pointer = 0, storage: T[] = []) {
    this.capacity = capacity;
    this.pointer = pointer;
    this.storage = storage;
  }

  enqueue(item: T): void {
    if (this.size() === this.capacity) {
      throw Error("Queue has reached max capacity, you cannot add more items");
    }
    this.storage.push(item);
  }

  dequeue(): T | undefined {
    return this.storage.shift();
  }

  moveForward(): T | undefined {
    if (this.pointer < this.size() - 1) this.pointer++;
    else this.pointer = 0;

    return this.storage[this.pointer];
  }

  moveBack(): T | undefined {
    if (this.pointer > 0) this.pointer--;
    else this.pointer = this.size() - 1;

    return this.storage[this.pointer];
  }

  getCurrentElement(): T | undefined {
    return this.storage[this.pointer];
  }

  getCurrentIndex(): number {
    return this.pointer;
  }

  size(): number {
    return this.storage.length;
  }

  remove(index: number): T | undefined {
    return this.storage.splice(index, 1)[0];
  }

  private toObject() {
    return {
      capacity: this.capacity,
      pointer: this.pointer,
      storage: this.storage,
    };
  }

  serialize() {
    return JSON.stringify(this.toObject());
  }

  static unserialize<T>(serialized: string) {
    const circularQueueObject: ReturnType<CircularQueue<T>["toObject"]> = JSON.parse(serialized);

    return new CircularQueue(circularQueueObject.capacity, circularQueueObject.pointer, circularQueueObject.storage);
  }

  getStorage() {
    return this.storage;
  }
}
